import React from "react"
import { Button, ButtonLoader } from "../../components/Button"
import { Card, CardModal, CardTitle } from "../../components/Card"
import { componentType } from "../../components/Chart"
import { FormRow, Input, Label } from "../../components/Form"
import { HeaderContent } from "../../components/Header"
import { LinkOrUpload } from "../../components/LinkOrUpload"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import { isValidURL } from "../../core/utils/validateFields"
import { AssistanceModal } from "../AssistanceAnalysisScreen"
import ManejeCover from "../../assets/img/maneje.png"
import "./styles.scss"
import ReportPathTopicsHeader from "../../components/ReportPathTopicsHeader"

const PathTopicsModal = ({
  register,
  errors,
  loading,
  onSavePathTopics,
  modalIsOpen,
  setModalIsOpen,
  onChangeFile,
  uploadedImage,
}) => {
  return (
    <>
      {modalIsOpen.newPathTopicsIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen.newPathTopicsIsOpen}>
          <ModalHeader
            closeModal={() => setModalIsOpen({ newPathTopicsIsOpen: false })}
            title="Novo Tópico"></ModalHeader>
          <ModalBody>
            <CardModal>
              <FormRow>
                <Label label="Titulo" />
                <Input
                  placeholder={"Digite aqui o titulo"}
                  register={register("title", {
                    required: { value: true, message: "Campo Obrigatório" },
                  })}
                  hasError={errors.title?.message}
                />
              </FormRow>
              <div className="card-reports-cover">
                <LinkOrUpload
                  labelInput="Link da Imagem"
                  placeholderInput="Digite aqui o link da Imagem"
                  labelButton={uploadedImage ? "Editar Imagem" : "Upload Imagem"}
                  name="linkImage"
                  register={register}
                  handleFileChange={onChangeFile}
                  errors={errors.linkImage?.message}
                  acceptFile="image/png"
                  nameFile="picture"
                  required={{
                    validate: (value) =>
                      isValidURL(value) || "Url Inválida. Ex: https://www.manejebem.com",
                  }}
                />
              </div>
            </CardModal>
          </ModalBody>
          <ModalFooter>
            <ButtonLoader
              loading={loading}
              label={"Salvar"}
              color="orange"
              handleClick={onSavePathTopics}
            />
          </ModalFooter>
        </ModalPanel>
      )}
    </>
  )
}

const AssistanceAnalysisReportsScreen = ({
  reportData,
  showPreviewClusteredPathTopics,
  gotToClusteredPathTopics,
  register,
  errors,
  loading,
  onSavePathTopics,
  onSaveReportListPath,
  modalIsOpen,
  setModalIsOpen,
  uploadedImage,
  onChangeFile,
  processingFile,
  clusteredPathTopics,
  selectedCard,
}) => {
  return (
    <>
      <ReportPathTopicsHeader data={reportData} setModalIsOpen={setModalIsOpen} />
      <Card className="reports-path-list-card no-border">
        <HeaderContent>
          <CardTitle title="Tópicos" className="flex-start"></CardTitle>
        </HeaderContent>
        <div className="reports-path-list-container">
          <div className="reports-path-list-card-folders">
            {reportData?.path_topics?.length > 0 &&
              reportData?.path_topics.map((item) => (
                <Card
                  className={`card-folder card-folder--${
                    item.id === selectedCard ? "active" : "inactive"
                  }`}
                  onClick={() => showPreviewClusteredPathTopics(item)}>
                  <div
                    className="card-folder-image"
                    style={{ backgroundImage: `url(${item.image || ManejeCover})` }}
                  />
                  <div className="card-folder-content">
                    <div className="card-content-info">
                      <h4>{item?.title}</h4>
                      <span>
                        <strong>{item?.clustered_charts.length || 0}</strong> Agrupamentos
                      </span>
                    </div>
                  </div>
                </Card>
              ))}
          </div>
        </div>
      </Card>

      {clusteredPathTopics?.length > 0 &&
        clusteredPathTopics?.map((item) => (
          <Card className="clustered-charts-card no-border">
            <HeaderContent>
              <CardTitle title={item?.title} className="flex-start"></CardTitle>
              <div className="clustered-charts-button-details">
                <Button
                  label="Ver Detalhes"
                  color="tertiary-orange"
                  handleClick={() => gotToClusteredPathTopics(item)}
                />
              </div>
            </HeaderContent>
            <div className="analysis-clustered-charts-card-folders">
              {item.components.map((item, index) => (
                <Card className="card-folder">
                  <div className="card-folder-content">
                    <div className="card-content-info">
                      <h4>{item.question.split(":")[1]}</h4>
                      <span>
                        <strong>Indíce:</strong> {item.question.split(":")[0]}
                      </span>
                    </div>

                    {componentType(item.type, {
                      data: item,
                      backgroundColor: index % 2 === 0 && "#DFE4E1",
                      keyWord: item.title,
                      value: "VALUE",
                      col: item?.col || 6,
                      noLabels: true,
                    })}
                  </div>
                </Card>
              ))}
            </div>
          </Card>
        ))}
      <PathTopicsModal
        {...{
          register,
          errors,
          loading,
          onSavePathTopics,
          modalIsOpen,
          setModalIsOpen,
        }}
      />
      <AssistanceModal
        {...{
          register,
          errors,
          uploadedImage,
          onChangeFile,
          loading,
          processingFile,
          onSaveReportListPath,
          modalIsOpen,
          setModalIsOpen,
          updateList: true,
        }}
      />
    </>
  )
}

export default AssistanceAnalysisReportsScreen
